import './add-outside-person.scss';
import template from './add-outside-person.html';

export class AddOutsidePersonController {
  constructor($log, $mdDialog, $mdToast, moment, PinCodeService) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.PinCodeService = PinCodeService;

    this.errorMessage = '';
    this.person = {
      startDate: null,
      endDate: null
    };
  }

  save(form) {
    form.$setSubmitted();
    if (form.$invalid) {
      return;
    }

    this.PinCodeService.addAuthorizedOutsidePerson({
      ...this.person,
      startDate: this.moment(this.person.startDate).format('YYYY-MM-DD'),
      endDate: this.moment(this.person.endDate).format('YYYY-MM-DD'),
      studentUserId: Number(this.student.studentUserId)
    })
      .then(response => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Dodano osobę uprawnioną')
            .position('bottom right')
            .hideDelay(3000)
        );
        this.$mdDialog.hide(response);
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.detailsError({
            locals: {error}
          })
        );
      });
  }

  closeDialog() {
    this.$mdDialog.cancel();
  }
}

export const AddOutsidePerson = {
  bindings: {
    student: '<'
  },
  controller: AddOutsidePersonController,
  template
};
